import React from 'react';
import { Form1008 } from './components/Form1008';
export function App() {
  return <div className="min-h-screen bg-slate-100 py-8" data-id="element-0">
      <Form1008 data-id="element-1" />
    </div>;
}